import { makeStyles } from "tss-react/mui";
import get from "lodash/get";
import { ChipColor, ChipSize } from "./ColoredChip.types.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ColoredChip_styles_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else ColoredChip_styles_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
const getWidth = (width, px)=>{
    if (!width) return 'fit-content';
    if ('number' == typeof width && px) return px(width);
    return width;
};
const commonProps = (tokens, px)=>({
        font: {
            size: tokens.typography.variant.body3.fontSize,
            lineHeight: tokens.typography.variant.body3.lineHeight
        },
        borderRadius: tokens.radius.m,
        icon: {
            fontSize: px(14),
            width: tokens.spacing['20'],
            height: tokens.spacing['20'],
            marginRight: tokens.spacing['10'],
            marginLeft: tokens.spacing['10']
        },
        counter: {
            marginLeft: tokens.spacing['10']
        }
    });
const sizeScheme = (tokens, px)=>({
        [ChipSize.large]: _object_spread_props(_object_spread({}, commonProps(tokens, px)), {
            height: px(48),
            padding: `14px ${tokens.spacing['16']}px`
        }),
        [ChipSize.medium]: _object_spread_props(_object_spread({}, commonProps(tokens, px)), {
            height: px(40),
            padding: `${tokens.spacing['10']}px ${tokens.spacing['16']}px`,
            icon: _object_spread_props(_object_spread({}, commonProps(tokens, px).icon), {
                marginRight: tokens.spacing['8'],
                marginLeft: tokens.spacing['8']
            }),
            counter: {
                marginLeft: tokens.spacing['8']
            }
        }),
        [ChipSize.small]: _object_spread_props(_object_spread({}, commonProps(tokens, px)), {
            height: px(32),
            padding: `6px ${tokens.spacing['12']}px`,
            icon: _object_spread_props(_object_spread({}, commonProps(tokens, px).icon), {
                marginRight: tokens.spacing['8'],
                marginLeft: tokens.spacing['8']
            }),
            counter: {
                marginLeft: tokens.spacing['8']
            }
        }),
        [ChipSize.extraSmall]: _object_spread_props(_object_spread({}, commonProps(tokens, px)), {
            height: px(24),
            borderRadius: tokens.radius.s,
            icon: {
                fontSize: tokens.spacing['12'],
                width: tokens.spacing['16'],
                height: tokens.spacing['16'],
                marginRight: tokens.spacing['4'],
                marginLeft: tokens.spacing['4']
            },
            padding: `${tokens.spacing['4']}px ${tokens.spacing['8']}px`,
            font: {
                size: tokens.typography.variant.caption.fontSize,
                lineHeight: tokens.typography.variant.caption.lineHeight
            },
            counter: {
                marginLeft: tokens.spacing['4']
            }
        })
    });
const colorScheme = {
    [ChipColor.gray]: {
        color: (p)=>p.text.primary,
        bgColor: (p)=>p.background.greyscalePrimary,
        counterBgColor: 'gray'
    },
    [ChipColor.darkgray]: {
        color: (p)=>p.text.tertiary,
        bgColor: (p)=>p.background.greyscaleTertiary,
        counterBgColor: 'gray'
    },
    [ChipColor.green]: {
        color: (p)=>p.success.main,
        bgColor: (p)=>p.success.light,
        counterBgColor: 'lightGreen'
    },
    [ChipColor.orange]: {
        color: (p)=>p.warning.main,
        bgColor: (p)=>p.warning.light,
        counterBgColor: 'lightOrange'
    },
    [ChipColor.red]: {
        color: (p)=>p.error.main,
        bgColor: (p)=>p.error.light,
        counterBgColor: 'lightRed'
    },
    [ChipColor.blue]: {
        color: (p)=>p.blue.main,
        bgColor: (p)=>p.blue.light,
        counterBgColor: 'lightBlue'
    },
    [ChipColor.purple]: {
        color: (p)=>p.review.main,
        bgColor: (p)=>p.review.light,
        counterBgColor: 'lightPurple'
    },
    [ChipColor.white]: {
        color: (p)=>p.background.lightPrimary,
        bgColor: (p)=>p.background.lightPrimary,
        counterBgColor: 'white'
    }
};
const useStyles = makeStyles()(({ palette, tokens, px }, { size, fullWidth, color, borderColor, disabled, width, isBgWhite })=>({
        container: {
            color: disabled ? tokens.colors.text.light.tertirary : colorScheme[color].color(palette),
            position: 'relative',
            width: getWidth(width, px)
        },
        chip: _object_spread_props(_object_spread(_object_spread_props(_object_spread({
            height: sizeScheme(tokens, px)[size].height,
            width: fullWidth ? '100%' : 'fit-content',
            borderRadius: sizeScheme(tokens, px)[size].borderRadius
        }, borderColor && {
            borderColor: get(tokens.colors, borderColor)
        }), {
            padding: sizeScheme(tokens, px)[size].padding,
            fontSize: sizeScheme(tokens, px)[size].font.size,
            lineHeight: sizeScheme(tokens, px)[size].font.lineHeight
        }), isBgWhite && {
            backgroundColor: tokens.colors.bg.light.primary
        }, !isBgWhite && {
            backgroundColor: disabled ? tokens.colors.bg.greyscale.secondary : colorScheme[color].bgColor(palette)
        }), {
            '& .MuiSvgIcon-root': {
                margin: 0,
                color: disabled ? tokens.colors.text.light.tertirary : colorScheme[color].color(palette)
            },
            '& .MuiChip-label': {
                padding: 0,
                overflow: 'visible'
            },
            '& .MuiChip-label .MuiTypography-root': {
                padding: 0,
                fontWeight: tokens.typography.variant.body3.fontWeight,
                fontSize: sizeScheme(tokens, px)[size].font.size,
                lineHeight: sizeScheme(tokens, px)[size].font.lineHeight,
                color: disabled ? tokens.colors.text.light.tertirary : colorScheme[color].color(palette)
            }
        }),
        chipLabel: {
            display: 'flex',
            alignItems: 'center',
            color: disabled ? tokens.colors.text.light.tertirary : colorScheme[color].color(palette)
        },
        chipLabelTypography: {
            color: `${!disabled ? colorScheme[color].color(palette) : tokens.colors.text.light.tertirary} !important`
        },
        icon: {
            display: 'flex',
            alignItems: 'center'
        },
        startIcon: {
            marginRight: sizeScheme(tokens, px)[size].icon.marginRight
        },
        endIcon: {
            marginLeft: sizeScheme(tokens, px)[size].icon.marginLeft
        },
        counter: {
            marginLeft: sizeScheme(tokens, px)[size].counter.marginLeft
        },
        counterSticked: {
            position: 'absolute',
            top: -tokens.spacing['8'],
            right: 0
        },
        linkChip: {
            cursor: 'pointer'
        }
    }));
export { colorScheme, useStyles };
